import * as types from 'model/actionTypes'
import { DictT, AccountProfileT } from 'model/types'

export function receiveAccountsProfiles (profiles: DictT<AccountProfileT>) {
  return {
    type: types.RECEIVE_ACCOUNTS_PROFILES,
    profiles
  }
}
